<template>
  <div class="grid lg:grid-cols-2 sm:grid-cols-2 gap-md mb-xl">
    <div>
      <p class="product-paragraph">
        Components and Coverage of {{ productType }} Insurance Policies
      </p>
      <ul class="product-list">
        <li v-for="(item, index) in coverageItems" :key="index" class="staggered-list-item">
          <span class="text-dark product-list-item">{{ item }}</span>
        </li>
      </ul>
    </div>
    <div class="flex items-center justify-center">
      <slot name="image">
        <img :src="bookImagePath" :alt="`${productType} Insurance`" class="max-w-full" />
      </slot>
    </div>
  </div>
</template>

<script>
import bookImage from '@/assets/images/products/banners/book.png';

export default {
  name: 'ProductPageCoverage',
  props: {
    productType: {
      type: String,
      required: true
    },
    coverageItems: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      bookImagePath: bookImage
    };
  }
};
</script>

<style scoped>
.product-list-item {
  color: var(--color-text-dark) !important;
}
</style> 